(ns client-portal.client.routes)

(def routes {:home {:uri "/"}

             #_conversations
             :conversations/list {:uri "/conversations/list"
                                  :roles [:some [:conversations-admin]]
                                  :dispatch [:conversations/list-go-with-params]
                                  :label "Conversation Console"}

             #_drive-thru
             :drive-thru/locations-list {:uri "/drive-thru/locations"
                                         :roles [:some [:drive-thru-admin]]
                                         :dispatch [:drive-thru/locations-list-go-with-params]
                                         :label "Drive-Thru Management"}
             :drive-thru/location {:uri "/drive-thru/location/:concept-id/:location-id"
                                   :roles [:some [:drive-thru-admin]]}

             :drive-thru/post {:uri "/drive-thru/location/:concept-id/:location-id/:mac-address"
                               :roles [:some [:drive-thru-admin]]}

             #_voice-commerce
             :vc {:uri "/vc"
                  :roles [:some [:voice-commerce-user]]
                  :label "Dashboard"}
             :vc/orders {:uri "/vc/orders"
                         :roles [:some [:voice-commerce-user]]
                         :label "Orders"}
             :vc/agent {:uri "/vc/a"
                        :roles [:some [:admin]]
                        :label "Data Questions"}
             :vc/agent-session {:uri "/vc/a/:session-id"
                                :roles [:some [:admin]]
                                :label "Data Questions"}

             #_smart-ordering
             :so/sessions {:uri "/so/sessions"
                           :roles [:some [:smart-ordering-user]]
                           :label "Sessions"}
             :so/asr-training {:uri "/so/asr-training"
                               :roles [:some [:asr-training-user]]
                               :label "ASR Training"}
             :so/agent {:uri "/so/a"
                        :roles [:some [:smart-ordering-user]]
                        :label "Data Questions"}
             :so/agent-session {:uri "/so/a/:session-id"
                                :roles [:some [:smart-ordering-user]]
                                :label "Data Questions"}

             #_oasys
             :oasys/agent {:uri "/oasys/a"
                           :roles [:some [:oasys-user]]
                           :label "Data Questions"}
             :oasys/agent-session {:uri "/oasys/a/:session-id"
                                   :roles [:some [:oasys-user]]
                                   :label "Data Questions"}

             #_voice-insights
             :vi {:uri "/vi"
                  :roles [:some [:voice-insights-user]]
                  :label "Dashboard"}
             :vi/locations {:uri "/vi/locations"
                            :roles [:some [:voice-insights-user]]
                            :label "Locations"}
             :vi/sessions {:uri "/vi/sessions"
                           :roles [:some [:voice-insights-user]]
                           :label "Sessions"}
             :vi/items {:uri "/vi/items"
                        :roles [:some [:voice-insights-user]]
                        :label "Items"}
             :vi/ces {:uri "/vi/ces"
                      :roles [:some [:voice-insights-user]]
                      :label "Customer Effort Scores"}
             :vi/duration {:uri "/vi/duration"
                           :roles [:some [:voice-insights-user]]
                           :label "Duration"}
             :vi/upsell {:uri "/vi/upsell"
                         :roles [:some [:voice-insights-user]]
                         :label "Upsell"}
             :vi/ai-analyst {:uri "/vi/ai-analyst"
                             :roles [:some [:admin]]
                             :label "AI Analyst"}
             ;; The Voice Insights summary agent, resolved from the user's agent list
             ;; (no ?agentId, no agent picker) — see chat.data/summary-agents.
             :vi/agent {:uri "/vi/a"
                        :roles [:some [:voice-insights-user]]
                        :label "Data Questions"}
             :vi/agent-session {:uri "/vi/a/:session-id"
                                :roles [:some [:voice-insights-user]]
                                :label "Data Questions"}
             :ai-agent/new {:uri "/ai-agent"
                            :roles [:some [:admin]]
                            :label "Data Questions"}
             :ai-agent/session {:uri "/ai-agent/:session-id"
                                :roles [:some [:admin]]
                                :label "Agent Session"}

             #_reports
             :reports/list {:uri "/reports/list"
                            :roles [:some [:reports-user]]
                            :label "Reports"}
             :reports/individual {:uri "/reports/i/:report-id"
                                  :roles [:some [:reports-user]]
                                  :label "Report"}
             :reports/individual-session {:uri "/reports/i/:report-id/:session-id"
                                          :roles [:some [:reports-user]]
                                          :label "Report"}
             :reports/individual-edit {:uri "/reports/i/:report-id/edit/:session-id"
                                       :roles [:some [:reports-user]]
                                       :label "Edit Report"}
             :reports/new {:uri "/reports/new"
                           :roles [:some [:reports-user]]
                           :label "New Report"}
             :reports/new-session {:uri "/reports/new/:session-id"
                                   :roles [:some [:reports-user]]
                                   :label "New Report"}})
